import { createAction, createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const biNotebookNotesByTagRequest = createRequest(constants.biNotebookNotesByTag);
export const biNotebookNotesByTagSuccess = createSuccess(constants.biNotebookNotesByTag);
export const biNotebookNotesByTagFailure = createFailure(constants.biNotebookNotesByTag);

export const biNotebookNotesByDateAndTagRequest = createRequest(constants.biNotebookNotesByDateAndTag);
export const biNotebookNotesByDateAndTagSuccess = createSuccess(constants.biNotebookNotesByDateAndTag);
export const biNotebookNotesByDateAndTagFailure = createFailure(constants.biNotebookNotesByDateAndTag);

export const biNotebookNotesByDateRequest = createRequest(constants.biNotebookNotesByDate);
export const biNotebookNotesByDateSuccess = createSuccess(constants.biNotebookNotesByDate);
export const biNotebookNotesByDateFailure = createFailure(constants.biNotebookNotesByDate);

export const setLoadingState = createAction(constants.setLoadingState);

export const requestBINotebookNotesByTag = biNotebookNotesByTagRequest;
export const requestBINotebookNotesByDateAndTag = biNotebookNotesByDateAndTagRequest;
export const requestBINotebookNotesByDate = biNotebookNotesByDateRequest;
